export default __webpack_public_path__ + "static/media/dt3.2e026dd9.webp";